import React from "react";
import { Dropdown as DropdownComponent } from "./Dropdown";
import { DropdownProvider } from "#library/components/Dropdown/components/Provider";
export var Dropdown = function Dropdown(props) {
  return /*#__PURE__*/React.createElement(DropdownProvider, null, /*#__PURE__*/React.createElement(DropdownComponent, props));
};
export { defaultProps, DROPDOWN_MENU_PLACEMENTS } from "./Dropdown";
Dropdown.Item = DropdownComponent.Item;
Dropdown.Menu = DropdownComponent.Menu;
Dropdown.TriggerButton = DropdownComponent.TriggerButton;
Dropdown.TriggerMenuItem = DropdownComponent.TriggerMenuItem;